import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core';
import DialogTitle from '../../../components/Dialog/DialogTitle';
import FormCreate from './FormCreate';
import { fetchSegmentLists, unsetError, updateStream, storePosts, updatePosts} from '../../../../config/redux';
import { connect } from 'react-redux';
import { useEffect } from 'react';

const Create = (props) => {

    const registerBtnRef = React.createRef();
    const { open, handleClose, loading, error, segments, loadingSegment } = props;

    const handleDialogClose = () => {
        props.unsetError();
        handleClose();
    }

    const handleStore = () => {
        registerBtnRef.current.click();
    }

    useEffect( () => {
        loadSegments();
    }, []);

    const loadSegments = () => {
        props.fetchSegments();
    }

    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            scroll='body'
        >
            <DialogTitle
                onClose={true}
                onHandleClose={handleDialogClose}
            >
                { props.postEdit ? `Edit Berita` : `Tambah Berita`}
            </DialogTitle>
            <DialogContent>
                <FormCreate 
                    error={error || {}}
                    lists={segments}
                    postEdit={props.postEdit || null}
                    listsLoading={loadingSegment}
                    onSubmit={ (params) => props.storeData(params)}
                    onUpdate={ (params) => props.updateData(params)}
                    registerBtnRef={registerBtnRef}
                />
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={handleStore}
                    variant="contained"
                    style={{
                        width: 120
                    }}
                    disabled={ loading }
                    color="primary">
                        { loading ?
                            <CircularProgress 
                                size={25} 
                            />
                            :
                            props.postEdit ? `Update` : `Simpan`
                        }
                </Button>
                <Button 
                    onClick={handleDialogClose}
                    variant="contained"
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => ({
    loading: state.posts.postStoreLoading,
    stream: state.posts.postStore,
    error: state.posts.postStoreError
});

const mapDispatchToProps = dispatch => ({
    storeData: (params) => dispatch(storePosts(params)),
    updateData: (params) => dispatch(updatePosts(params)),
    fetchSegments: () => dispatch(fetchSegmentLists()),
    unsetError: () => dispatch(unsetError())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);